import { render, staticRenderFns } from "./NOTLINKED.vue?vue&type=template&id=ce2ac064&scoped=true"
import script from "./NOTLINKED.vue?vue&type=script&lang=js"
export * from "./NOTLINKED.vue?vue&type=script&lang=js"
import style0 from "./NOTLINKED.vue?vue&type=style&index=0&id=ce2ac064&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2ac064",
  null
  
)

export default component.exports